import React from 'react'

export default function Tranning() {
  return (
    <div>Tranning</div>
  )
}

